import { render, staticRenderFns } from "./ClassicInfinityDimensionRow.vue?vue&type=template&id=a5c514bc&"
import script from "./ClassicInfinityDimensionRow.vue?vue&type=script&lang=js&"
export * from "./ClassicInfinityDimensionRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports